import DetailHeader from './../DetailHeader';
import PatientBreadCrumb from './../PatientBreadCrumb';
import PatientInformation from './../PatientInformation';

import * as PATIENT from '@/store/constants/patient';

import {mapActions} from 'vuex';

export default {
  name: 'PatientDetail',
  data() {
    return {
      patient: {}
    }
  },
  components: {
    DetailHeader,
    PatientBreadCrumb,
    PatientInformation
  },

  computed: {
    fullName() {
      return (this.patient)
        ? this.patient.last_name + ' ' + this.patient.first_name
        : null;
    }
  },

  methods: {
    ...mapActions({
      getPatient: PATIENT.ACTION_GET_PATIENT
    }),

    /**
     * Back to list.
     */
    backToList() {
      this.$router.push({name: 'PatientList'});
    },

    /**
     *  Handle get patient.
     *
     * @param id
     */
    handleGetPatient(id) {
      this.getPatient(id).then((patient) => {
        this.patient = patient.data;
      });
    },

    init() {
      if (this.$route.params['patient']) {
        this.patient = this.$route.params['patient'];
      } else {
        const patientId = this.$route.params['id'] || null;

        console.log(patientId);
        // Query the detail from the patient.
        if (!patientId) {
          this.backToList();
        }
        // Get patient and appointment.
        this.handleGetPatient(patientId);
      }
    }
  },

  created() {
    this.init();
  }
}


// WEBPACK FOOTER //
// ./src/views/Patient/Detail/js/patient-detail.js